import { render } from "./DetailsPatient.vue?vue&type=template&id=6f8d8f17&scoped=true"
import script from "./DetailsPatient.vue?vue&type=script&lang=js"
export * from "./DetailsPatient.vue?vue&type=script&lang=js"

import "./DetailsPatient.vue?vue&type=style&index=0&id=6f8d8f17&lang=postcss&scoped=true"
import "./DetailsPatient.vue?vue&type=style&index=1&id=6f8d8f17&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8d8f17"]])

export default __exports__